import { SignUpQuestionId } from '../../questionService/questionModules/signUpQuestionModules'
import { SignUpScreen } from '../types'

export enum SignUpScreenId {
  WHEN_TO_START = 'WHEN_TO_START',
  NEED_MORE_INFO_EARLY_STAGE = 'NEED_MORE_INFO_EARLY_STAGE',
  NEED_MORE_INFO_LATE_STAGE = 'NEED_MORE_INFO_LATE_STAGE',
  WHAT_TO_CALL_YOU = 'WHAT_TO_CALL_YOU',
}

export const signUpScreens: { [key in SignUpScreenId]: SignUpScreen } = {
  [SignUpScreenId.WHEN_TO_START]: {
    title: 'Hello!',
    description:
      'Thanks for considering Gaia as a partner in your IVF journey.',
    helperText: undefined,
    buttonText: 'Next',
    backText: 'Back',
    questions: [SignUpQuestionId.WHEN_TO_START],
  },
  // todo: consider combining NEED_MORE_INFO_LATE_STAGE and NEED_MORE_INFO_EARLY_STAGE to q/screen with dynamic copy
  [SignUpScreenId.NEED_MORE_INFO_LATE_STAGE]: {
    title: undefined,
    description:
      "Great! We need a bit of info to estimate your price and create a Gaia Quote that caps and fixes your treatment costs. We'll ask about...",
    helperText: undefined,
    buttonText: "Let's do it",
    backText: 'Back',
    questions: [SignUpQuestionId.NEED_MORE_INFO_LATE_STAGE],
  },
  [SignUpScreenId.NEED_MORE_INFO_EARLY_STAGE]: {
    title: undefined,
    description:
      "Before we can offer you a Gaia plan, we'd like to ask you a few questions such as Any previous IVF cycles  Any consultations you've had already Details about you and your fer Your upcoming IVF plans We're committed to helping everyone no matter what stage you're at. If you're just researching your options, join our community to receive information and tips on how to prepare for the journey ahead.",
    helperText: undefined,
    buttonText: "Let's do it",
    backText: 'Back',
    questions: [SignUpQuestionId.NEED_MORE_INFO_EARLY_STAGE],
  },
  [SignUpScreenId.WHAT_TO_CALL_YOU]: {
    title: undefined,
    description: 'What should we call you?',
    helperText: undefined,
    buttonText: 'Next',
    backText: 'Back',
    questions: [
      SignUpQuestionId.FIRST_NAME,
      SignUpQuestionId.EMAIL,
      SignUpQuestionId.EMAIL_CONSENT,
    ],
  },
}
